import { useMemo } from 'react';
import { env } from 'features/common/config/envConfig';
import { transformTenants } from 'features/user-groups/components/CreateTeamDrawer/utils';
import { useGetOrganizationTenantsQuery } from 'gql/graphql';
import { useFeature } from 'lib/featureFlags/features';

export const useTransformedTenants = () => {
  const { data: tenantsData, loading: tenantsLoading } =
    useGetOrganizationTenantsQuery({
      variables: { first: 100, env },
    });

  const isScaiDamEnabled = useFeature('SCAI_DAM');

  const transformedTenants = useMemo(
    () => transformTenants(tenantsData, isScaiDamEnabled),
    [tenantsData, isScaiDamEnabled],
  );

  return {
    transformedTenants,
    tenantsLoading,
  };
};
